<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">New Inspection Service Type</p>
            </header>
            <section class="modal-card-body">
                <o-field label="Inspection Type">
                    <o-input></o-input>
                </o-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click.prevent="success" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    export default {
        methods: {
            success() {
                this.$swal.fire({
                    text: 'Inspection service type has been successfull created',
                    icon: 'success'
                })
            }, 
        },
    }
</script>